import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              专题合集
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
              按主题精选的韩国漫画合集，一站式发现同类型佳作
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
            {indexItems.slice(0, 7).map((item, i) => (
              <a
                key={i}
                href="#cards"
                className={`group block bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 no-underline cursor-pointer ${
                  i === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
                }`}
              >
                <div className={`relative w-full ${i === 0 ? 'aspect-[2/1]' : 'aspect-[4/3]'} overflow-hidden`}>
                  <img
                    src={item.cover}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      (e.currentTarget as HTMLElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-base md:text-lg font-heading font-bold text-white mb-1">{item.title}</h3>
                    <span className="text-xs text-white/70">{item.count} 部作品</span>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}